import * as React from "react";
import { observer } from "mobx-react";

interface Props {}

const initialState = {};
type State = Readonly<typeof initialState>;

@observer
export class DevTools extends React.Component<Props, State> {
  readonly state: State = initialState;

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./app/components/devTools/DevTools.tsx